// @ts-check
import required from 'utils/required';

import { UPDATE_PENDING_REFERRALS_COUNT } from 'agent_portal/actions/ReferralsActions';
import { NEW_REFERRAL_RECEIVED } from 'agent_portal/actions/NewReceivedReferralsActions';

const initialState = {
  pendingReferralsCount: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PENDING_REFERRALS_COUNT:
      const { pendingReferralsCount = required('pendingReferralsCount') } = action.payload;
      return {
        ...state,
        pendingReferralsCount,
      };
    case NEW_REFERRAL_RECEIVED:
      return {
        ...state,
        pendingReferralsCount: state.pendingReferralsCount + 1, // This is a naive approach because other pending referrals may not be pending anymore, which means this count could be incorrect
      };
    default:
      return state;
  }
};

export default reducer;
